var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLucky(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 18,
    viewBox: "0 0 64 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1023_21087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.35925 17.6479H0.131104V0.198853H2.87183V14.9072H7.35925V17.6479Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6916 17.8467C11.494 17.8467 10.5307 17.5059 9.80177 16.8243C8.97102 16.0267 8.55566 14.938 8.55566 13.5581V0.198853H11.2964V13.5581C11.2964 14.1735 11.4124 14.5889 11.6443 14.8042C11.8763 15.0196 12.2254 15.119 12.6916 15.1024C13.1555 15.1024 13.4963 15.0031 13.7141 14.8042C13.9318 14.6054 14.0561 14.1901 14.0868 13.5581V0.198853H16.8311V13.5581C16.8311 14.9048 16.4157 15.9935 15.585 16.8243C14.8205 17.5083 13.8561 17.8491 12.6916 17.8467Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6143 17.8467C21.4499 17.8467 20.4866 17.5059 19.7245 16.8242C18.8937 15.9935 18.4784 14.9048 18.4784 13.5581V4.2886C18.4784 2.94191 18.8937 1.85319 19.7245 1.02245C20.489 0.340817 21.4522 0 22.6143 0C23.7764 0 24.7397 0.340817 25.5041 1.02245C26.3349 1.82005 26.7503 2.90877 26.7503 4.2886V5.83292H24.0095V4.2886C24.0095 3.67324 23.8936 3.25788 23.6616 3.0425C23.4297 2.82712 23.0806 2.72771 22.6143 2.74428C22.1481 2.74428 21.8072 2.84368 21.5919 3.0425C21.3765 3.2413 21.2523 3.65669 21.2191 4.2886V13.5616C21.2191 14.1604 21.3434 14.5758 21.5919 14.8077C21.8404 15.0397 22.1812 15.1391 22.6143 15.106C23.0971 15.106 23.4462 15.0066 23.6616 14.8077C23.877 14.6089 23.993 14.1936 24.0095 13.5616V11.3179H26.7503V13.5616C26.7503 14.9415 26.3349 16.0302 25.5041 16.8278C24.7728 17.5094 23.8096 17.8491 22.6143 17.8467Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1701 17.6479H34.2269L32.1073 12.0635L31.1595 14.2327V17.6479H28.4188V0.198853H31.1595V7.27788L34.2021 0.198853H37.1701L33.6553 8.47429L37.1701 17.6479Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8765 11.5168V17.6479H41.1106V11.5168L37.7417 0.198853H40.6314L42.4775 6.45425L44.3734 0.198853H47.2631L43.8765 11.5168Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5091 8.673C54.5091 8.673 54.9208 7.23872 55.2545 5.79737C55.7553 3.62822 56.0179 0.912342 54.3315 0.25911C51.5306 -0.82724 50.8702 2.10875 50.8702 2.10875C50.8702 2.10875 47.8382 1.01885 47.7709 4.45185C47.7423 5.82578 48.8217 6.54289 50.1567 7.12512C52.1624 8.00201 54.5091 8.673 54.5091 8.673Z",
    fill: "#9FA7B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5715 1.74671C56.096 1.45915 55.155 8.52044 55.155 8.52044C55.155 8.52044 62.2591 11.5097 63.5478 8.74408C64.8364 5.97851 61.8295 5.14777 61.8295 5.14777C61.8295 5.14777 63.0508 2.03427 59.5715 1.74671Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9636 8.99963C54.9636 8.99963 52.3114 16.5366 55.0772 17.6159C58.0023 18.7591 58.7763 15.7237 58.7763 15.7237C58.7763 15.7237 62.5749 16.7958 62.0709 13.274C61.6165 10.1144 54.9636 8.99963 54.9636 8.99963Z",
    fill: "#9FA7B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3672 8.96058C54.3672 8.96058 47.9875 6.04237 46.4041 9.09195C44.8207 12.1415 48.0548 12.7593 48.0548 12.7593C48.0548 12.7593 47.3165 15.7698 50.3022 16.1461C53.2878 16.5224 54.3672 8.96058 54.3672 8.96058Z",
    fill: "#9FA7B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1023_21087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.7377,
    height: 18,
    fill: "white",
    transform: "translate(0.131104)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLucky);
export default __webpack_public_path__ + "static/media/lucky.80a1f9c3e9ba439a41930e56f850ea36.svg";
export { ForwardRef as ReactComponent };